import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {},
        },
        item: {},
        deleteIp: false,
        ip: null,
    },
    getters: {
        items: state => state.items,
        item: state => state.item,
        deleteIp: state => state.deleteIp,
        ip: state => state.ip,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setItem(state, item) {
            state.item = item;
        },
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('freeradius/checks', {params: rootState.route.query});

            commit('setItems', response.data);

            return response;
        },
        async store({ commit }, payload) {
            const response = await http.post('freeradius/checks', payload);

            return response;
        },
        async update({ commit }, payload) {
            const response = await http.patch(`freeradius/checks/${payload.id}`, payload);

            return response;
        },
        async deactivate({ commit }, id) {
            const response = await http.patch(`freeradius/checks/${id}/deactivate`);

            return response;
        },
        async activate({ commit }, id) {
            const response = await http.patch(`freeradius/checks/${id}/activate`);

            return response;
        },
        async delete({ commit }, id) {
            const response = await http.delete(`freeradius/checks/${id}`);

            return response;
        }
    }
}